var map = {
	"./cash-white": 9,
	"./cash-white.png": 9,
	"./checkbox-filled-in": 10,
	"./checkbox-filled-in.png": 10,
	"./custom-select": 11,
	"./custom-select.png": 11,
	"./favicon": 6,
	"./favicon.ico": 184,
	"./favicon.png": 6,
	"./glg-premium": 12,
	"./glg-premium.png": 12,
	"./golf-background": 13,
	"./golf-background.jpg": 13,
	"./icon/danger": 14,
	"./icon/danger.svg": 14,
	"./icon/four_player_scramble": 15,
	"./icon/four_player_scramble.png": 15,
	"./icon/individual_stableford": 16,
	"./icon/individual_stableford.png": 16,
	"./icon/success": 17,
	"./icon/success.svg": 17,
	"./icon/two_player_bestball": 18,
	"./icon/two_player_bestball.png": 18,
	"./icon/warning": 19,
	"./icon/warning.svg": 19,
	"./logo-black": 20,
	"./logo-black.png": 20,
	"./logo-branding": 21,
	"./logo-branding.png": 21,
	"./logo-icon": 22,
	"./logo-icon.png": 22,
	"./logo-outings-blue": 23,
	"./logo-outings-blue.png": 23,
	"./logo-outings-text": 24,
	"./logo-outings-text.png": 24,
	"./logo-text": 25,
	"./logo-text.png": 25,
	"./logo-white": 26,
	"./logo-white.png": 26,
	"./xleague-branding": 27,
	"./xleague-branding.png": 27,
	"./xleague_logo": 28,
	"./xleague_logo.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183;